
<template>
  <v-app>
    <v-main>
        <NuxtLoadingIndicator />
        <NuxtLayout>
          <NuxtPage />
        </NuxtLayout>
    </v-main>
  </v-app>
</template>
